import React, { useState } from "react";
import Modal from "react-modal";
import Container from "../../components/Container";
import { theme, websiteColors } from "../../themes/Theme.js";
import konfpurple_svg from "/public/logos/revamp-icons-blue.svg";
import konfwhite_svg from "/public/logos/konfhub-logo-white.svg";
import poweredkonfwhite_svg from "/public/logos/Powered-konfhub-logo-white.svg";
import poweredkonfpurple_svg from "/public/logos/revamp-powerd-konfhub-logo.svg";
import konficonpurple_svg from "/public/logos/revamp-konfhub-blue-logo.svg";
import konficonwhite_svg from "/public/logos/konfhub-icon-white.svg";
import konfhubPoweredbylogo from "/public/logos/konfhubBluelogo.png";
import konfhubBluelogo1 from "/public/logos/konfhubBluelogo1.png";
import konfhubPoweredby from "/public/logos/konfhubPoweredby.png";
import LogosModal from "../../components/Modal/LogosModal";
const logos = [{
  name: "konfpurple",
  svg: konfpurple_svg,
  png: konfhubPoweredbylogo
}, {
  name: "konfwhite",
  svg: konfwhite_svg,
  png: "/logos/konfhub-logo-white.png"
}, {
  name: "poweredkonfpurple",
  svg: poweredkonfpurple_svg,
  png: konfhubPoweredby
}, {
  name: "poweredkonfwhite",
  svg: poweredkonfwhite_svg,
  png: "/logos/Powered-konfhub-logo-white.png"
}, {
  name: "konficonpurple",
  svg: konficonpurple_svg,
  png: konfhubBluelogo1
}, {
  name: "konficonwhite",
  svg: konficonwhite_svg,
  png: "/logos/konfhub-icon-white.png"
}
// {
// 	name: "konficonwhite",
// 	svg: konficonpurple_svg,
// 	png: "/logos/konfhub-icon-white.png",
// },
];
const BrandAssetCard = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [img, setImg] = useState("");
  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      minWidth: "32px",
      maxWidth: "550px",
      minHeight: "32px",
      maxHeight: "80vh"
    }
  };
  const openModal = logoName => {
    setImg(logoName);
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return <Container className="konfhub d-flex flex-column align-items-center justify-content-center" style={{
    minHeight: '100vh'
  }} data-sentry-element="Container" data-sentry-component="BrandAssetCard" data-sentry-source-file="BrandAssetCard.jsx">
			<h2 className="header-text mb-5 font-weight-bold">KonfHub Logos</h2>
			<div className="row mb-5 ">
				<div className="d-flex flex-sm-column flex-md-row flex-lg-row justify-content-center align-items-center flex-wrap">
					{logos.map(logo => <div className="parent-card me-lg-4 mb-5 me-md-3 p-3" key={logo.name}>
							<div className="card card-style">
								<img className="icon-placement" src={logo.svg} alt={`This is ${logo.name}'s logo`} />
							</div>
							<div className="btngrp-class">
								<a target="_blank" href={logo.png} download className="btn btn-class me-2">
									.PNG
								</a>
								<a href={logo.svg} download className="btn btn-class me-2">
									.SVG
								</a>
								<a onClick={() => openModal(logo.name)} className="btn btn-class">
									EMBED
								</a>
							</div>
						</div>)}
				</div>
				<div className="download-zip">
					<a href="https://media.konfhub.com/kh-logos.zip" className="d-flex app-menu-item host-event mx-lg-3 mx-md-2 px-4 py-3 gap-3 justify-content-center align-items-center fs-5 hover-class download-button-container" download>
						<p>Download All Logos</p>

						<i className="fa fa-download"></i>{" "}
					</a>
				</div>
			</div>
			<Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyles} contentLabel="Example Modal" data-sentry-element="Modal" data-sentry-source-file="BrandAssetCard.jsx">
				<LogosModal setIsOpen={setIsOpen} ImgType={img} data-sentry-element="LogosModal" data-sentry-source-file="BrandAssetCard.jsx" />
			</Modal>
			<style jsx>
				{`
					.header-text {
						margin-top: 40px;
						margin-bottom: 0.5rem;
						font-weight: 500;
						line-height: 1.2;
						color:#002E6E;
						text-align: center;
						font-size: calc(1.325rem + 0.9vw);
					}
					 .download-zip{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .download-zip> download-button-container{
                        gap: 14px;
                        font-size: 30px;
                        color: #572148;
                        font-family: Nunito;
                        font-weight: bold;
                        display: block;
                    }
					
                    .download-zip> download-button-container{
                        gap: 14px;
                        font-size: 30px;
                        color: #572148;
                        font-family: Nunito;
                        font-weight: bold;
                        display: block;
                    }
					 .app-menu-item{
                        font-size: 16px;
                        //box-shadow: 0 1px 5px rgb(0,0,0,.5);
                        line-height: 24px;
                        background-color: #002E6E;
                        border-radius: 5px;
                        color: white;
                        font-weight : 400;
                        //border: 2px solid #fb5850;
                        -webkit-text-decoration: none;
                        text-decoration: none;
                    }
                    .app-menu-item:hover{
                       // background: #d9443d;
                        color: white;
                    }
					.card-style {
						height: 250px;
						width: 250px;
						box-shadow: 0px 4px 5px rgb(0 0 0 / 15%) !important;
						background-color: rgba(1, 46, 111, 0.14);
						border-radius: 8px;
						justify-content: center;
						display: flex;
					}
					.download-zip {
						display: flex;
						align-items: center;
						justify-content: center;
					}
					.btn-class {
						color:${websiteColors[theme].primaryBackgroundColor};
						border: 1px solid ${websiteColors[theme].primaryBackgroundColor};
						background: #E1F0FF;
					}
					
					.parent-card {
						border: 1px solid #D9D9D9;
						position: relative;
						height: 360px;
						width: 285px;
						border-radius: 8px;
					}
					.btngrp-class {
						display: flex;
						align-items: center;
						justify-content: center;
						position: absolute;
						bottom: 10px;
						left: 50px;
						right: 50px;
					}
					.icon-placement {
						width: 200px;
						margin: auto;
					}
				`}
			</style>
		</Container>;
};
export default BrandAssetCard;